import { Link } from 'react-router-dom'
import { Bell, Target } from 'lucide-react'
import type { DreamBoardCard } from '../../services/dreamService'

/**
 * Hold me to it, on a dream (Dreams UX pass 2026-09-06; the same call as
 * goals and skills): a dream is never reminded about — the tasks and habits
 * under its goals are. The dream board carries no item-level facts, so this
 * block names the live goals once and points at their pages, where the
 * reminders live. Until 2026-09-12 it restated each goal's "next", which the
 * Plan block and the Journey already said (North Star rule 2).
 */
export function DreamHoldMeToIt({ card, headingClass }: { card: DreamBoardCard | null; headingClass: string }) {
  const live = (card?.goals || []).filter((g) => g.live)
  const resting = (card?.goals || []).filter((g) => !g.live && String(g.status || '').toLowerCase() !== 'completed')
  return (
    <div data-testid="dream-hold">
      <h3 className={headingClass}><Bell className="h-3.5 w-3.5 text-brand" /> Hold me to it</h3>
      {live.length === 0 ? (
        <p className="mt-1.5 text-sm text-secondary" data-testid="dream-hold-empty">
          {resting.length ? 'Its goals are paused, so nothing is reminding you right now. Reminders show here from the live goals under it.' : 'Reminders are set on the tasks and habits under each goal and show up here. No goal is under it yet.'}
        </p>
      ) : (
        <p className="mt-1.5 flex items-start gap-2 text-sm text-secondary" data-testid="dream-hold-items">
          <span className="mt-0.5 shrink-0 text-muted" aria-hidden="true"><Target className="h-3.5 w-3.5" /></span>
          <span className="min-w-0">
            Reminders are set on the tasks and habits under{' '}
            {live.map((g, i) => (
              <span key={g.id}>{i > 0 ? (i === live.length - 1 ? ' and ' : ', ') : ''}<Link to={`/goals/${g.id}`} className="font-medium text-primary hover:text-brand hover:underline" data-testid="dream-hold-goal">{g.title}</Link></span>
            ))}
            {live.length === 1 ? ', and live on its page.' : ', and live on their pages.'}
          </span>
        </p>
      )}
    </div>
  )
}

export default DreamHoldMeToIt
